import Vue from "vue";
import Router from "vue-router";
import { ComponentsRouter } from "../components/RedbayComponents";
import MainPage from "../components/template/MainPage.vue";
import WelcomePage from "../components/template/WelcomePage.vue";
import ProductPage from "../components/template/ProductPage.vue";
import SearchPage from "../components/template/SearchPage.vue";
import VetDirectContact from "../components/template/VetDirectContact.vue";
import Udawaj from "../components/template/Udawaj.vue";
import ClearPass from "../components/template/ClearPass.vue";
import ReturnsPage from "../components/template/ReturnsPage.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    ...ComponentsRouter(),
    {
      path: "/",
      name: "mainPage",
      component: MainPage
    },
    {
      title: "Home Page - Example App",
      path: "/welcome",
      name: "welcomePage",
      component: WelcomePage
    },
    {
      path: "/product/:id/:slug",
      name: "productPage",
      component: ProductPage,
      props: true
    },
    {
      path: "/search",
      name: "searchPage",
      component: SearchPage
    },
    {
      path: "/contact",
      name: "contact",
      component: VetDirectContact
    },
    {
      path: "/pl/udawaj",
      name: "udawajPage",
      component: Udawaj
    },
    {
      path: "/clearpass",
      name: "clearPass",
      component: ClearPass
    },
    {
      path: "/returns",
      name: "returnsPage",
      component: ReturnsPage
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js